import { FundFamilyStateMachineFieldsEnum } from "gen/model/fundFamilyStateMachineFieldsEnum";
import { HypotheticalPerformanceFundFamilyFilterOptions } from "gen/model/hypotheticalPerformanceFundFamilyFilterOptions";
import { useTranslation } from "react-i18next";
import { SelectButton } from "shared/components/input/select/SelectButton";
import { SelectOption } from "shared/components/input/select/SelectOption";

export interface FundFamilySelectButtonProps {
  fundFamilyFilterOptions: HypotheticalPerformanceFundFamilyFilterOptions[];
  selectedFundFamilyIds: string[] | undefined | null;
  onSelectedFundFamilyIdsChange: (selectedFundFamilyIds: string[]) => void;
}

export const FundFamilySelectButton: React.FC<FundFamilySelectButtonProps> = ({
  fundFamilyFilterOptions,
  selectedFundFamilyIds,
  onSelectedFundFamilyIdsChange,
}) => {
  const { t } = useTranslation(["common", "fundFamily", "enums"]);
  return (
    <SelectButton
      value={selectedFundFamilyIds}
      onChangeValue={onSelectedFundFamilyIdsChange}
      title={t("common:fundFamily")}
      isFilterButton={true}
      isMulti={true}
      size="sm"
    >
      {fundFamilyFilterOptions.map((filterOption) => (
        <SelectOption
          key={filterOption.id}
          value={filterOption.id}
          isDisabled={filterOption.is_disabled}
          labelRight={
            !filterOption.is_disabled
              ? t(
                  "fundFamily:config.performanceConfig.fundFamilyFilterDropdownDate",
                  { date: filterOption.date_quarter.period_rich_value },
                )
              : filterOption.fund_family_state ==
                  FundFamilyStateMachineFieldsEnum.dissolved
                ? t("enums:FundFamilyStateMachineFieldsEnum.dissolved")
                : t("common:disabled")
          }
        >
          {filterOption.name}
        </SelectOption>
      ))}
    </SelectButton>
  );
};
